<div class="offboarding-request-container">
  <div style="display: flex; justify-content: space-between; align-items: start;">
    <app-title-field [title]="'Create Off-boarding Request'"></app-title-field>
    <div class="close-button" (click)="closeForm()">
      <app-title-field [icon]="'close'" [title]="' '"></app-title-field>
    </div>
  </div>
  <form>
    <div class="form-row">
      <app-input-field [label]="'PS ID'" [(ngModel)]="psId" [cssClass]="'form-input'" [type]="'text'" [required]="true"
                       [disabled]="isPsIdDisabled" name="psId"></app-input-field>
      <mat-form-field class="form-input" appearance="outline" floatLabel="always"
                      [ngClass]="{'dateOfReturnCond': selectedStatus.toLowerCase() !== 'done'}">
        <mat-label>Date of Return</mat-label>
        <input matInput [matDatepicker]="pickerDateOfReturn" [(ngModel)]="dateOfReturn" name="dateOfReturn" placeholder="MM/DD/YYYY">
        <mat-datepicker-toggle matIconSuffix [for]="pickerDateOfReturn" ></mat-datepicker-toggle>
        <mat-datepicker #pickerDateOfReturn></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field class="form-input" appearance="outline" floatLabel="always">
        <mat-label>Date of Off-boarding</mat-label>
        <input matInput [matDatepicker]="pickerDateOfOffboarding" [(ngModel)]="dateOfOffboarding" name="dateOfOffboarding" placeholder="MM/DD/YYYY">
        <mat-datepicker-toggle matIconSuffix [for]="pickerDateOfOffboarding"></mat-datepicker-toggle>
        <mat-datepicker #pickerDateOfOffboarding></mat-datepicker>
      </mat-form-field>
      <div class="status-label-container">
        <app-status-label [statusV]="selectedStatus" [showDropdown]="true" [category]="'Return'"
                          (statusChange)="onStatusChanged($event)"
                          style="flex: 1; min-width: 0;">
        </app-status-label>
      </div>
    </div>
      <div class="form-row">
      <app-dropdown class="form-input" [options]="releaseTypeOptions"
          [id]="'release_type'" [label]="'Release Type'" 
          [valueKey]="'value'" [displayKey]="'label'" [(ngModel)]="releaseType"
          (selectionChange)="onReleaseTypeChange($event)" [required]="true" name="releaseType">
      </app-dropdown>
      <div>
   <app-dropdown  *ngIf="releaseType === 'Involuntary'" class="form-input" [options]="reasonOptions"
          [id]="'reason'" [label]="'Reason'" 
          [valueKey]="'value'" [displayKey]="'label'" [(ngModel)]="reason"
          (selectionChange)="onReasonChange($event)" 
          [required]="true" name="reason">
      </app-dropdown>
      </div>
    </div>

    <div class="form-row">
      <div class="form-input" style="width:100%">
         <label for="comments">Comments<span style="color: red;">*</span></label>
        <textarea id="comments" [(ngModel)]="comments" rows="4" class="form-textarea" style="width:100%"
                  name="comments" required>
				</textarea>
      </div>
    </div>
    <div class="form-actions">
      <app-button-group [label]="'Cancel'" [buttonType]="'Secondary'"
                        (onEmit)="handleCancel()" [cssClass]="'cancel-btn'"></app-button-group>
      <app-button-group [label]="'Save'" [buttonType]="'Primary'" [disabled]="isSaveDisabled" (onEmit)="handleSubmit()"></app-button-group>
    </div>
  </form>
</div>
